import React from 'react';

const WhatIsTheDom = () => (
    <section className='white-content'>
    WhatIsTheDom
    </section>
)

export default WhatIsTheDom;